"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerVehicleDto = void 0;
const CustomerProfileDto_1 = require("../customer-profiles/CustomerProfileDto");
class CustomerVehicleDto {
    constructor(params) {
        this.isDealervault = false;
        this.isOpentrack = false;
        if (!params) {
            return;
        }
        this.isDealervault = false;
        this.isOpentrack = false;
        this.id = params.id;
        this.customerProfileId = params.customerProfileId;
        this.vin = params.vin;
        this.year = params.year;
        this.make = params.make;
        this.model = params.model;
        this.name = params.name;
        this.odometerReading = params.odometerReading;
        this.odometerUpdatedDate = params.odometerUpdatedDate;
        this.estimatedAnnualMileage = params.estimatedAnnualMileage;
        this.lastServiceDate = params.lastServiceDate;
        this.imageUrl = params.imageUrl;
        this.customData = params.customData;
        this.additionalProperties = params.additionalProperties;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.isOpentrack !== undefined) {
            this.isOpentrack = params.isOpentrack;
        }
        if (params.isDealervault !== undefined) {
            this.isDealervault = params.isDealervault;
        }
        if (params.customerProfile !== undefined) {
            this.customerProfile = params.customerProfile ?
                new CustomerProfileDto_1.CustomerProfileDto(params.customerProfile) :
                null;
        }
    }
}
exports.CustomerVehicleDto = CustomerVehicleDto;
//# sourceMappingURL=CustomerVehicleDto.js.map